var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"text-4xl pb-10 md:text-6xl md:pb-12"},[_vm._t("default"),(_vm.englishTitle)?_c('div',{staticClass:"text-2xl md:text-3xl pt-3"},[_vm._v(_vm._s(_vm.englishTitle))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }